import socketio from 'socket.io-client';
import { settings as Settings } from './__settings';
import { Utiles } from '@/__env/pluggins/event-bus';
//import { ChatAdmin } from '@/views/a-chat/chat-controlador';
//import { ChatAdminML } from '@/views/a-chat-ml/chat-controlador';


class WebSocket
{

    constructor()
    {

    }

    public Autenticado: boolean = false;
    public async Init()
    {
        socket.addEventListener( 'connect', this.onConect );
        //socket.addEventListener( 'reconnect', () =>  this.onConect( self ) );

        socket.io.uri = Settings.URL.api;
        socket.io.autoConnect = true;
        socket.connect();
        this.IniciarEventos();
    }

    onConect()
    {
        //console.log( 'ws connect' );
    }

    Autenticar()
    {
        this.Autenticado = true;
        if ( !socket.connected )
        {
            socket.connect();
        }
        this.IniciarEventos();
    }

    IniciarEventos()
    {
        if ( this.Autenticado )
        {
            socket.emit( 'registrer' );
            //ChatAdminML.Iniciar();
            //ChatAdmin.Iniciar();
        }
    }
}

export const socket = socketio( '0', { autoConnect: false, reconnection: true } );
export const SocketAdmin = new WebSocket();